import { createApp } from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue/es'
import 'ant-design-vue/dist/antd.css'
import router from './router'
import store from './store'

const app = createApp(App)
app.config.productionTip = false
app.use(store)
app.use(router)
app.use(Antd)
app.mount('#app')
